export enum PacientsCategory {
  Children = "CHILDREN",
  Adults = "ADULTS"
}

export const PATIENTS_CATEGORY_LABELS = {
  [PacientsCategory.Children]: "Copii",
  [PacientsCategory.Adults]: "Adulți"
};
